<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.go(-1)" />

                <div class="header-block location-center">
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                    </div>
                    <div class="label">
                        + {{ $t('financePage.balance') }}
                    </div>
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                    </div>
                </div>

                <div class="balance-info-text">
                    {{ $t('addBalancePage.enterTheAmount') }}<br>{{ $t('addBalancePage.whichYouWantAddToBalance') }}
                </div>

                <div class="balance-container">
                    <uzhnet-input v-model="balance" :placeholder="'0.00'" :alignText="'right'"/>
                </div>

                <div class="balance-footer">
                    <uzhnet-button @click="createFillBalanceTransacton" class="login-form__button" :label="$t('addBalancePage.next')" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router'
import { useMainStore } from '@/store/mainStore'
import ApiManager from '@/services/ApiManager'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils';
import { getAccountByLogin, dropAllAccounts } from '@/db/accountService';

function formatDescriptionInHtml(inputHtml) {
    // Регулярний вираз для пошуку description
    const descriptionRegex = /"description":"(.*?)"/;

    // Знайти description у рядку
    const match = inputHtml.match(descriptionRegex);

    if (match && match[1]) {
        const encodedDescription = match[1];

        // Декодуємо текст із символами Unicode
        const decodedDescription = JSON.parse(`"${encodedDescription}"`);

        // Замінюємо старе значення на декодоване
        const updatedHtml = inputHtml.replace(
            descriptionRegex,
            `"description":"${decodedDescription}"`
        );

        return updatedHtml;
    } else {
        console.error("Description not found in the input HTML string.");
        return inputHtml; // Повертаємо початковий HTML, якщо description не знайдено
    }
}

export default {
    name: "AddBalancePage",

    setup() {
        const router = useRouter()
        const store = useMainStore()

        const balance = ref(null)

        const createFillBalanceTransacton = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            const response = await ApiManager.fillBalance(auth_token, {
                summa: balance.value
            })

            const formHtml = formatDescriptionInHtml(response.data.html_content)

            const action = formHtml.match(/action="([^"]*)/)[1] // get action from form
            const method = formHtml.match(/method="([^"]*)/)[1] // get method from form
            const id = formHtml.match(/id="([^"]*)/)[1] // get id from form

            const form = document.createElement('form')
            form.action = action
            form.method = method
            form.id = id
            form.innerHTML = formHtml
            document.body.appendChild(form)
            form.submit()

            router.push('/payment-success')
        }

        return {
            balance,
            createFillBalanceTransacton
        }
    }
}
</script>
<style lang="scss" scoped>
    .balance-info-text {
        font-size: 14px;
        text-align: center;
        margin-top: 60px;
        margin-bottom: 60px;
        color: #C7C8D1;
    }

    .balance-container {
        padding: 10px 20px;
    }

    .balance-footer {
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }
</style>
